/* eslint-disable react/no-unused-prop-types */
import { Box, createMuiTheme, Grid, ThemeProvider } from '@material-ui/core'
import styled from 'styled-components'
import React, { useState } from 'react'
import { SectionHeader, FotterWidthButtons } from './main'
import SectionDivider from './sectionDivider'
import format from 'date-fns/format'
import frLocale from 'date-fns/locale/es'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import SmartInput from '../../../components/smartInputs/group'
import useApointmentCalculator from './useApointmentCalculator'
import propTypes, { number, string } from 'prop-types'
import { Alert } from '@material-ui/lab'
import handleScrollItonView from './handleScrollIntoView'
import { frontTheme } from '../../components/layout_user/index'
import useDisableDates from '../../../hooks/useDisableDates'
import { toString } from '../../../helpers/date'

const theme = createMuiTheme({
  ...frontTheme,
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&:hover $notchedOutline': {
          borderColor: 'var(--first)'
        }
      }
    }
  }
})

const Text = styled.div`
  font-size: 1.5em;
  text-align: center;
  color: var(--first);
  font-family: 'imlbold'; font-weight: bold;
`

// const SubText = styled(Text)`
//   font-size: .95em;
//   font-weight: normal;
//   text-align: left;
// `

// const TextFooter = styled.div`
//   font-size: .9em;
//   color: var(--first);
//   font-family: 'imlregular';
// `

const Body = styled.div`
  margin: 5em 0em;
`

const Footer = styled.div`
  margin-top: 2em;
`
const SmarInputsStyled = styled(SmartInput)`
  fieldset {
    border-color: var(--first);
    :hover {
      border-color: var(--first)!important;
    }
  }
`

class LocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText (date) {
    return format(date, 'd MMM yyyy', { locale: this.locale })
  }
}

const Calendar = props => {
  const [error, setError] = useState(false)
  const { day, handleChangeDay, hour, handleHourChange, availableHours, date, config } = useApointmentCalculator(props.value)
  const disableDays = useDisableDates()

  const handleConfirm = () => {
    if (date && !config.loading && validateEndDate(config.end, date)) {
      props.onConfirm(date)
    } else {
      handleScrollItonView()
      return setError(true)
    }
  }

  const handleDisableDays = (date) => {
    // if (date.getDay() === 0 || date.getDay() === 6) return true
    if (disableDays.loading) return false
    if (disableDays.items.map(d => toString(d)).includes(toString(date))) return true
    return false
  }

  const validateEndDate = (end, date) => {
    try {
      const endHours = end.getHours()
      const endMinutes = end.getMinutes()
      const endFullMinutes = (endHours * 60) + endMinutes
      console.log('end', end, endHours, endMinutes, endFullMinutes)

      const dateHours = date.getHours()
      const dateMinutes = date.getMinutes()
      const dateFullMinutes = (dateHours * 60) + dateMinutes
      console.log(date, dateHours, dateMinutes, dateFullMinutes)
      return dateFullMinutes <= endFullMinutes
    } catch (error) {
      console.log('validateEndDateError', error)
      return false
    }
  }

  return (
    <MuiPickersUtilsProvider utils={LocalizedUtils} locale={frLocale}>
      <ThemeProvider theme={theme}>
        <SectionDivider step={1}>
          <SectionHeader
            title='Elige el día y la hora de tu cita'
            subtitle={`Las citas son cada ${props.interval} minutos Lunes a Viernes de ${props.init}-${props.end} y Sábados de ${props.saturdayInit}-${props.saturdayEnd}`}
          />
          <Body>
            <Grid container>
              {!!Object.keys(availableHours).length && error && (
                <Grid item xs={12}>
                  <Box mb={3}>
                    <Alert severity='error'>Porfavor elija una fecha y hora</Alert>
                  </Box>
                </Grid>
              )}
              {!Object.keys(availableHours).length && (
                <Grid item xs={12}>
                  <Box mb={3}>
                    <Alert severity='error'>No hay citas disponibles para la fecha seleccionada</Alert>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} md={6} container justify='center'>
                <Grid item xs={12}>
                  <Text>Día</Text>
                </Grid>
                <DatePicker
                  shouldDisableDate={handleDisableDays}
                  value={day}
                  onChange={handleChangeDay}
                  variant='static'
                  disableToolbar
                  disablePast
                  inputVariant='filled'
                />
              </Grid>
              <Grid item xs={12} md={6} container justify='center' style={{ minHeight: '250px' }}>
                <Grid item xs={12}>
                  <Text>Hora</Text>
                </Grid>
                <Grid item xs={8}>
                  <SmarInputsStyled
                    type='select'
                    options={availableHours}
                    label={hour ? undefined : 'Elija una opción'}
                    onChange={handleHourChange} value={hour}
                    disabled={!Object.keys(availableHours).length}
                  />
                  <Box marginBottom='.5em' />
                  {/* <SubText>
                    SELECCIONA UN HORARIO ENTRE: <br />
                    <b>LUNES A VIERNES 7:15 A 18:00 HRS</b><br />
                    <b>SÁBADO DE 7:15 A 14:00 HRS</b>
                  </SubText> */}
                </Grid>
                <Grid item xs={12}>
                  <FotterWidthButtons justify='center' onConfirm={handleConfirm} hideBack />
                </Grid>
              </Grid>
            </Grid>
            <Footer>
              {/* <TextFooter>*Los 30 minutos se pueden reducir a cada 15 minutos de acuerdo al aumento de volumen de pacientes.</TextFooter> */}
              {/* <TextFooter>*La disponibilidad de turnos se incrementará de acuerdo con la demanda del servicio.</TextFooter>
              <TextFooter>*Lo anterior para garantizar que el resultado estará el mismo día después de las 7:00 pm</TextFooter> */}
            </Footer>
          </Body>
        </SectionDivider>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  )
}

Calendar.propTypes = {
  onConfirm: propTypes.func,
  value: propTypes.any,
  interval: number,
  init: string,
  end: string,
  saturdayInit: string,
  saturdayEnd: string
}

export default Calendar
